<template>
    <modal id="reverse-payment-modal"
           v-model="showModal"
           :loading="loading"
           :preloader="preloader" :title="generateModalTitle('Reverse Payment')"
           @input="closeModal"
           @submit="submitData">

        <form
            ref="form"
            :data-url='REVERSE_PAYMENT_SAVE+orderId'>

            <app-form-group
                v-model="formData.paid_amount"
                type="number"
                class="mb-2"
                :label="$t('Total Reversed')"
                :disabled="true"
                :error-message="$errorMessage(errors, 'paid_amount')"
            />
            <app-form-group type="date" v-model="formData.payment_date" :label="$t('Date')"
                        :placeholder="$placeholder($t('Date'))" :readOnly="true" />
            <app-form-group
                v-model="formData.amount"
                type="number"
                class="mb-2"
                :label="$t('Amount')"
                :required="true"
                :error-message="$errorMessage(errors, 'amount')"
            />
            <div class="mb-3">
                <label for="paymentMode" class="form-label">Payment Mode:</label>
                <app-input type="select" :list="paymentModeOptions" list-value-field="value"
                        v-model="formData.payment_mode" :required="false" :placeholder="$placeholder('Payment Mode')" />
            </div>
            <app-form-group
                v-model="formData.payment_note"
                type="textarea"
                class="mb-2"
                :label="$t('Payment Note')"
                :required="false"
            />
        </form>

    </modal>

</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {DUE_PAYMENT_INFO, REVERSE_PAYMENT_SAVE, SELECTABLE_DROPDOWN} from "../../../../Config/ApiUrl-CP";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "ReversePaymentModal",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        orderId: {
            require: true
        },
    },
    data() {
        return {
            showNote: true,
            loading: false,
            REVERSE_PAYMENT_SAVE,
            DUE_PAYMENT_INFO,
            paymentModeOptions: [],
            formData: {
                due_amount: 0,
                amount: 0,
                payment_date: '',
                paid_amount: 0
            },
        }
    },
    watch: {
        'formData.amount':{
            handler: function (amount) {
                if(amount > this.formData.paid_amount) {
                    this.formData.amount = this.formData.paid_amount;
                }
            }
        }
    },
    methods: {
        paymentListOptions() {
            try {
                axiosGet(`${SELECTABLE_DROPDOWN}?list_id=14`).then(response => {
                    this.formData.payment_mode = response.data.data[0].id;
                    for (let item of response.data.data) {
                        this.paymentModeOptions.push({
                            id: item.id,
                            value: item.item_label,
                        });
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#reverse-payment-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'invoice-list-table');
        },
        getOrderInformation() {
            axiosGet(`${DUE_PAYMENT_INFO}/${this.orderId}`).then(response => {
                this.formData.paid_amount = response.data.paid_amount
            })
        },
        closeModal(eventData) {
            if (eventData) return;
            this.$emit('modal-close');
        }
    },
    mounted() {
        this.getOrderInformation()
        this.paymentListOptions()
    }
}
</script>
